import React from 'react';

function Flashcards() {
  return (
    <div>
      <h2>Flashcards Page (Coming Soon)</h2>
    </div>
  );
}

export default Flashcards;
